//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {mapState, mapMutations} from 'vuex'
  import {orderDetail, cancelOrder} from '../../service/index'
  import Api from '../../utils/config'
  import moment from 'moment'
import { setTimeout } from 'timers';
  import {MessageBox} from 'mint-ui';

  export default {
    data () {
      return {
        orderDetail: {},
        orderGoodsList: [],
        payment: Api.payment,
        paymentMb: Api.paymentMb,
        dialogVisible:false,
        expireDate: "",
        expireMinutes: 15,
        popoverVisible:false,
        confirmedDownloadInvoice: true
      }
    },
    created () {
      const orderId = this.$route.params.orderId
      this.getOrderDetail(orderId)
      this.keepLang()
    },
    computed: {
      ...mapState(['global','specName','specNameEn']),
      specNames(){
         return  this.$i18n.locale  === 'en' ? this.specNameEn : this.specName;
      },
      invalidGoodList(){
        if(this.orderDetail.lackItems){
          return JSON.parse(this.orderDetail.lackItems.replace("\\",""))
        }
      }
    },
    methods: {
      showDialog (){
        this.dialogVisible=true
      },
      async getOrderDetail (orderId) {
        const res = await orderDetail(orderId)
        if (res.status === 0) {
          this.orderDetail = res.data
          this.expireDate = moment(this.orderDetail.orderDate).add(this.expireMinutes, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          this.orderGoodsList = res.data.items
          if(this.orderDetail.status == 2 
            // && this.orderDetail.email != null && this.orderDetail.email.indexOf("@") < 0
          ) {
            // setTimeout(()=>{
            //   this.popoverVisible=true
            // },500)
            // console.log(this.orderDetail);
            // console.log(MessageBox)
            if(this.global.isPc){
              this.confirmedDownloadInvoice = false;
              this.$alert(this.$t('order.downloadVoiceConfirm'), '', {
                confirmButtonText:this.$t('order.affirm'),
                customClass:'download-invoice',
                center: true,
                callback: action => {
                  this.confirmedDownloadInvoice = true;
                }
              });
            }else{
              MessageBox.alert(this.$t('order.downloadVoiceConfirm'), "", {
                confirmButtonText: this.$t('order.affirm')
              });
            }

            


          }
        }
      },
      payMoney (orderId) {
        // this.$router.push({path: '/pay/' + orderId})
        window.location = Api.payment + orderId
      },
      keepLang(){
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
        this.$i18n.locale = 'en';
      },
      async cancel (orderId) {
        const res = await cancelOrder(orderId)
        if (res.status === 0) {
          this.dialogVisible=false
          this.$message({

            message: this.$t('order.cancelSuccess'),
            type: 'success'
          })
          this.orderDetail.status = 12
        }else{
          this.$message({
            message: this.$t('order.cancelFailed'),
            type: 'error'
          })
        }
      },
      exportDetail (orderId){
        window.location.href = "/is/store/order/exportDetail/" + orderId;
      },
      downloadDetail (orderId){
        window.location.href = "/is/store/order/downloadDetail/" + orderId;
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/order/OrderDetail.vue